module.exports = __webpack_public_path__ + "static/Paul-17f38cc314294c5d89064b08549bd41d.jpg";